(() => {
  let headerObserver;
  const update = () => {
    const group = document.getElementById('header-group');
    if (!group) return;
    const header = group.querySelector('#header-component');
    const height = Math.max(group.getBoundingClientRect().height, header?.getBoundingClientRect().height || 0);
    group.dataset.duvanzeScrolled = window.scrollY > 10 ? 'true' : 'false';
    if (height > 0) document.documentElement.style.setProperty('--duvanze-menu-height', height + 'px');
  };
  const initialize = () => {
    const group = document.getElementById('header-group');
    if (!group) return;
    headerObserver?.disconnect();
    headerObserver = new ResizeObserver(update);
    headerObserver.observe(group);
    const header = group.querySelector('#header-component');
    if (header) headerObserver.observe(header);
    update();
  };
  window.addEventListener('scroll', update, {passive:true});
  window.addEventListener('pageshow', initialize);
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
})();
